<div class="sticky-header">
    <div class="dashboard-summary">
        <!-- <div class="page-title">{{ reportName | translate }}</div> -->

        <div class="summary-top-row">
            <div class="breadcrumb-line">
                <span>{{ "Dashboard" | translate }}</span>

                <span>&gt;</span>

                <span>{{ reportName | translate }}</span>
            </div>

            <!-- <div class="allocation-pills" role="tablist" aria-label="Allocation level">
                @for (level of allocationLevels; track level) {
                    <button
                        type="button"
                        class="allocation-pill"
                        [class.allocation-pill--active]="selectedAllocationLevel === level"
                        (click)="selectAllocationLevel(level)"
                    >
                        {{ level | titlecase }} wise
                    </button>
                }
            </div> -->
        </div>
    </div>

    <div class="filters-container" [formGroup]="form">
        <div class="filter-section">
            <!-- <label for="state-select">State</label> -->
            <mat-select id="state-select" formControlName="state" placeholder="Select State" class="filter-input">
                <mat-option [value]="null">Select State</mat-option>
                @for (state of stateList; track state.state_id) {
                    <mat-option [value]="state.state_name_en">{{ state.state_name_en }}</mat-option>
                }
            </mat-select>
        </div>

        @if (showDistrictFilter) {
            <div class="filter-section">
                <!-- <label for="district-select">District</label> -->
                <mat-select id="district-select" formControlName="district" class="filter-input" placeholder="Select District">
                    <mat-option [value]="null">Select District</mat-option>
                    @for (district of districtList; track district.district_id) {
                        <mat-option [value]="district.district_name_en">{{ district.district_name_en }}</mat-option>
                    }
                </mat-select>
            </div>
        }

        @if (!isPEModule) {
            <div class="filter-section">
                <mat-select id="block-select" formControlName="block" placeholder="Select Block" class="filter-input">
                    <mat-option [value]="null">Select Block</mat-option>
                    @for (block of blockList; track block.block_id) {
                        <mat-option [value]="block.block_name_en">{{ block.block_name_en }}</mat-option>
                    }
                </mat-select>
            </div>
        }
    </div>
</div>

@if (jwtToken) {
    <fin-metabase-dashboard [token]="jwtToken" [withTitle]="false" [withDownloads]="false" [initialParameters]="initialParameters">
    </fin-metabase-dashboard>
} @else {
    <p>Token Generation in progress...</p>
}
